import moment from "moment";
const dateSort = (rowA, rowB) => {
    const a = moment(rowA.fe_pago,"DD/MM/YYYY").toDate();
    const b = moment(rowB.fe_pago,"DD/MM/YYYY").toDate();
    if (a > b) {
        return -1;
    }

    if (b > a) {
        return 1;
    }

    return 0;
};
const opeSort = (rowA, rowB)=>{
    const a = Number(rowA.nu_operacion);
    const b = Number(rowB.nu_operacion);
    if (a > b) {
        return -1;
    }

    if (b > a) {
        return 1;
    }

    return 0;
}
export const columnasContratos = [
    {
        id: 9,
        name: <span style={{ whiteSpace : "normal"}}>Ver Detalle</span>,
        selector: row=> row.cuotapago,
        style: { textAlign: 'center', justifyContent: 'center' },
        maxWidth: '100px',
        minWidth: '100px',
        compact : true
    },
    {
        id: 8,
        name: <span style={{ whiteSpace : "normal"}}>Fecha Vencimiento</span>,
        selector: row => row.fe_pago,
        style: { textAlign: 'center', justifyContent: 'center' },
        maxWidth: '170px',
        minWidth: '100px',
        sortable: true,
        sortFunction : dateSort,
        compact : true,
        conditionalCellStyles : [
            {
                when: row=> row.bloqueado === true,
                style : {
                    opacity : 0.5
                }
            }
        ]
    },
    {
        id: 7,
        name: <span style={{ whiteSpace : "normal"}}>Total Pago</span>,
        selector: row => row.mt_total_a_pagar,
        style: { textAlign: 'center', justifyContent: 'center' },
        maxWidth: '250px',
        minWidth: '80px',
        compact : true,
        conditionalCellStyles : [
            {
                when: row=> row.bloqueado === true,
                style : {
                    opacity : 0.5
                }
            }
        ]
    },
    {
        id: 6,
        name: <span style={{ whiteSpace : "normal"}}>Gasto de cobranza</span>,
        selector: row => row.mt_gasto_cobranza,
        style: { textAlign: 'center', justifyContent: 'center' },
        maxWidth: '170px',
        minWidth: '80px',
        compact : true,
        conditionalCellStyles : [
            {
                when: row=> row.bloqueado === true,
                style : {
                    opacity : 0.5
                }
            }
        ]
    },
    {
        id: 5,
        name:<span style={{ whiteSpace : "break-spaces"}}> Interés Mora </span>,
        selector: row => row.mt_interes_mora,
        style: { textAlign: 'center', justifyContent: 'center' },
        maxWidth: '170px',
        minWidth: '80px',
        compact : true,
        conditionalCellStyles : [
            {
                when: row=> row.bloqueado === true,
                style : {
                    opacity : 0.5
                }
            }
        ]
    },
    {
        id: 4,
        name: <span style={{ whiteSpace : "break-spaces"}}>Monto Cuota </span>,
        selector: row => row.mt_cuota,
        style: { textAlign: 'center', justifyContent: 'center' },
        maxWidth: '170px',
        minWidth: '80px',
        compact : true,
        conditionalCellStyles : [
            {
                when: row=> row.bloqueado === true,
                style : {
                    opacity : 0.5
                }
            }
        ]
    },
    {
        id: 3,
        name: "Concepto",
        selector: row => <span style={{ whiteSpace : "normal"}}>{row.tx_concepto}</span>,
        style: { textAlign: 'center', justifyContent: 'center' },
        maxWidth: '300px',
        minWidth: '120px',
        compact : true,
        conditionalCellStyles : [
            {
                when: row=> row.bloqueado === true,
                style : {
                    opacity : 0.5
                }
            }
        ]
    },
    {
        id: 2,
        name: "Cuota",
        selector: row => row.tx_cuota,
        style: { textAlign: 'center', justifyContent: 'center'},
        maxWidth: '150px',
        minWidth: '50px',
        compact : true,
        conditionalCellStyles : [
            {
                when: row=> row.bloqueado === true,
                style : {
                    opacity : 0.5
                }
            }
        ]
    },
    {
        id: 1,
        name: "Contrato",
        selector: row => row.nu_operacion_txt,
        style: { textAlign: 'center', justifyContent: 'center', },
        maxWidth: '170px',
        minWidth: '80px',
        sortable: true,
        sortFunction : opeSort,
        compact :true,
        conditionalCellStyles : [
            {
                when: row=> row.bloqueado === true,
                style : {
                    opacity : 0.5
                }
            }
        ]

    },

]
export const columnasCuotas = [
    {
        id: 1,
        name: "Cuota",
        selector: row => row.num_cuota,
        style: { textAlign: 'center' },
    },
    {
        id: 2,
        name: "Concepto",
        selector: row => row.concepto,
        style: { textAlign: 'center' },
    },
    {
        id: 3,
        name: "Monto",
        selector: row => row.monto,
        style: { textAlign: 'center' },
    },
    {
        id: 4,
        name: "Interés",
        selector: row => row.interes,
        style: { textAlign: 'center' },
    },

]
export const columnasCuotaPagos = [
	{
		name: 'Nº Cuota ',
		selector: row=>row.total,
		style: { justifyContent: 'center' },
	},
	{
		name: 'Valor Cuota',
		selector: row=>row.valor,
		style: { justifyContent: 'center' },
	},
	{
		name: 'Fecha Vencimiento ',
		selector: row=>row.fecha_vencimiento,
		style: { justifyContent: 'center' },
	},
	{
		name: 'Fecha de Pago ',
		selector: row=>row.fecha_pago,
		style: { justifyContent: 'center' },
	},
	{
		name: 'Estado de pago ',
		selector: row=>row.estado,
		style: { justifyContent: 'center' },
	},
	{
		name: 'Nº Factura',
		selector: row=>row.factura,
		style: { justifyContent: 'center' },
	}
];